export const itensMenu = [
  {
    key: 0,
    permission: "access_menu_home",
    url: "/",
    title: "Início",
    icon: "HomeOutlined",
  },
  {
    key: 1,
    permission: "visualiza_contratos_app",
    url: "/plan-contract-approval",
    title: "Aprovação de Contratos de Plano",
    icon: "CheckSquareOutlined",
  }
];